import React from 'react';

const STATE_LABEL = {
  lobby: 'En attente du démarrage',
  question: 'Question en cours',
  revealed: 'Révélation',
  ended: 'Session terminée'
};

const STATE_COLOR = {
  lobby:    'var(--color-text-muted, #95a5a6)',
  question: 'var(--participant-fill, #3498db)',
  revealed: 'var(--highlight-fill, #f39c12)',
  ended:    'var(--centroid-stroke, #27ae60)'
};

function Stat({ label, value, accent }) {
  return (
    <div style={{ textAlign: 'center', padding: '0.5rem 1rem' }}>
      <div style={{ fontSize: '0.75rem', color: 'var(--color-text-muted, #7f8c8d)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
        {label}
      </div>
      <div style={{ fontSize: '2.4rem', fontWeight: 700, color: accent || 'var(--color-text, #2c3e50)', lineHeight: 1 }}>
        {value}
      </div>
    </div>
  );
}

export default function AnimatorStatsPanel({ state, currentQuestionIndex, totalQuestions, stats }) {
  if (!stats) return null;
  const badgeColor = STATE_COLOR[state] || '#7f8c8d';
  const showQuestion = state === 'question' || state === 'revealed';

  return (
    <div
      style={{
        background: 'var(--color-surface, white)',
        color: 'var(--color-text, inherit)',
        border: '1px solid var(--color-border, transparent)',
        borderRadius: 8,
        padding: '1rem 1.5rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <span
          style={{
            display: 'inline-block',
            padding: '0.25rem 0.75rem',
            background: badgeColor,
            color: '#fff',
            borderRadius: 999,
            fontSize: '0.85rem',
            fontWeight: 600
          }}
        >
          {STATE_LABEL[state] || state}
        </span>
        {showQuestion && (
          <span style={{ color: 'var(--color-text, #34495e)', fontWeight: 600 }}>
            Question {currentQuestionIndex + 1} / {totalQuestions}
          </span>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-around', borderTop: '1px solid var(--color-border, #ecf0f1)', paddingTop: '0.5rem' }}>
        <Stat label="Connectés" value={`${stats.connectedCount}/${stats.totalCount}`} accent="var(--participant-fill, #3498db)" />
        <Stat label="Réponses" value={`${stats.answeredCount}/${stats.totalCount}`} accent={state === 'question' ? 'var(--highlight-fill, #f39c12)' : 'var(--centroid-stroke, #27ae60)'} />
      </div>
    </div>
  );
}
